import { useState, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ModuleGridWrapper from 'components/wrappers/ModuleGridWrapper';
import { RelationsProduct } from 'components/productPage/RelationsProduct';
import Wysiwyg from 'libs/wordpress/components/Wysiwyg';
import Text from 'components/Text';
import styled from 'libs/styled';
import Column from '@sportson/core-web/App/layouts/Column';
import Button from 'components/Button';

const StyledGridWrapper = styled(ModuleGridWrapper)`
    /* NOTE: Uncomment when client implemented highlighted product "tag"  */
    /* > a:first-of-type {
        grid-row: span 2;
    } */
`;

export const RelatedProductsAccessories = ({ products, heading }) => {
    const { t } = useTranslation();
    const [isExpanded, setIsExpanded] = useState(false);
    const itemsPerView = 3;

    const toggleProducts = useCallback(() => setIsExpanded((prev) => !prev), []);

    // TODO: Remove the manual filter for status_id when we have a proper handling of it in the API
    const visibleProducts = useMemo(
        () => (isExpanded ? products : products.slice(0, itemsPerView)),
        [isExpanded, products, itemsPerView],
    ).filter((product) => product.status_id === 1);

    if (!products) {
        return null;
    }

    return (
        <Column maxWidth="100%" gap="24px" padding={['40px 12px', null, '40px 12px', '40px 0']}>
            {heading?.text && (
                <Wysiwyg
                    data={heading.text}
                    TextComponent={(props) => (
                        <Text
                            textAlign="left"
                            as={heading?.type === 'default' ? 'h2' : heading.type}
                            color={heading?.textColor === 'default' ? 'var(--text-color-default)' : heading.textColor}
                            typography={['UI/20_100_0_450', null, null, null, 'Content/32_120_0_500']}
                            {...props}
                        />
                    )}
                />
            )}
            <StyledGridWrapper
                gridTemplateColumns={['100%', null, '1fr 1fr 1fr', null, null]}
                gridTemplateRows={isExpanded ? 'repeat(2, 1fr)' : '1fr'}
                columnGap="24px"
                rowGap="24px"
            >
                {Array.isArray(visibleProducts) &&
                    visibleProducts.map((product, i) => (
                        <RelationsProduct key={product.id} product={product} type="accessories" i={i} />
                    ))}
            </StyledGridWrapper>
            {products.length > itemsPerView && (
                <Button onClick={toggleProducts} margin="0 auto" theme="secondary">
                    {isExpanded ? t('pdp.show_less') : t('pdp.show_more')}
                </Button>
            )}
        </Column>
    );
};
